import { render, staticRenderFns } from "./PostFormModal.vue?vue&type=template&id=baafa0ae&scoped=true"
import script from "./PostFormModal.vue?vue&type=script&lang=js"
export * from "./PostFormModal.vue?vue&type=script&lang=js"
import style0 from "./PostFormModal.vue?vue&type=style&index=0&id=baafa0ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baafa0ae",
  null
  
)

export default component.exports